module.exports = __webpack_public_path__ + "static/04-f1b120e4488c308593dc2ead4d8ce9eb.jpg";